import React, {
  createContext,
  FunctionComponent,
  PropsWithChildren,
  useContext,
  useState,
} from 'react'

import { Proposer } from '../../../domain'
import { useErrorHandlingAsync } from '../../../hooks/errors'
import { usePrincipal } from '../PrincipalProvider'

interface ProposerContextObj {
  refresh: () => void
  proposer: Proposer | undefined
  setProposer: (proposer: Proposer) => void
}

export const ProposerContext = createContext<ProposerContextObj | undefined>(undefined)

export const ProposerProvider: FunctionComponent<PropsWithChildren> = (props) => {
  const { apiClient, user } = usePrincipal()

  const [proposer, setProposer] = useState<Proposer | undefined>(undefined)

  const { execute: refresh } = useErrorHandlingAsync(async () => {
    setProposer(await apiClient.getProposer())
  }, [user])

  return (
    <ProposerContext.Provider value={{ proposer, setProposer, refresh }}>
      {props.children}
    </ProposerContext.Provider>
  )
}

export const useProposer = (): ProposerContextObj => {
  const context = useContext(ProposerContext)
  if (!context) {
    throw new Error('Cannot use ProposerContext when undefined.')
  }
  return context
}
